const enUS = {
  components: {
    nav: {
      pagination: {
        nextLabel: "Next",
        previousLabel: "Previous",
      },
    },
    section: {
      newsletterCallout: {
        titleDefault:
          "Subscribe to our newsletter for the latest smart home innovations, data-driven analysis and expert guidance.",
        btnTextDefault: "Subscribe to newsletter",
        placeholderDefault: "Enter your email here",
      },
    },
  },
  pages: {
    index: {
      h1: "SmartRent.com Homepage",
      button: "A Button",
    },
  },
}

export default enUS
